/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.ts to modify the generation of this file.
const config = {};
config.sitecoreApiKey = process.env.SITECORE_API_KEY || '49F856C4-8FBC-4A12-A598-88AA1D2B66C6';
config.sitecoreApiHost = process.env.SITECORE_API_HOST || '';
config.sitecoreSiteName = process.env.SITECORE_SITE_NAME || 'Editorial';
config.graphQLEndpointPath = process.env.GRAPH_QL_ENDPOINT_PATH || '/sitecore/api/graph/edge';
config.defaultLanguage = process.env.DEFAULT_LANGUAGE || 'en';
config.graphQLEndpoint = process.env.GRAPH_QL_ENDPOINT || '/sitecore/api/graph/edge';
config.layoutServiceConfigurationName = process.env.LAYOUT_SERVICE_CONFIGURATION_NAME || 'sxa-jss';
config.publicUrl = process.env.PUBLIC_URL || '/editorial';
config.sitecoreEdgeUrl = process.env.SITECORE_EDGE_URL || 'https://edge-platform.sitecorecloud.io';
config.sitecoreEdgeContextId = process.env.SITECORE_EDGE_CONTEXT_ID || '2hWfS4bvdvULB0BtP7m5Hp';
module.exports = config;